import { render, staticRenderFns } from "./InputFile.vue?vue&type=template&id=5779854a&"
import script from "./InputFile.vue?vue&type=script&lang=ts&"
export * from "./InputFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports